/**
 * @deprecated Use downloadBlobFile instead.
 * This function limits the file size to 2MB due to data URI limitations.
 */
export default (nomeArquivo, conteudo) => {
  const a = document.createElement("a");
  a.href = `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURI(conteudo)}`;
  a.download = nomeArquivo;
  a.click();
};

/**
 * Downloads a file from blob content.
 * This function can handle larger files compared to data URI method.
 *
 * @param {string} fileName - The name of the file to be downloaded.
 * @param {BlobPart} blobContent - The content of the file as a BlobPart.
 * @param {string} contentType - The MIME type of the file.
 *
 * @example
 * // Example usage:
 * const csvContent = "col1,col2\nval1,val2";
 * downloadBlobFile("data.csv", csvContent, "text/csv");
 */
export function downloadBlobFile(fileName, blobContent, contentType) {
  const blob = new Blob([blobContent], { type: contentType });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();

  setTimeout(() => {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 0);

  URL.revokeObjectURL(url);
}
